export default {
    SERVER_URL: 'https://interface.recycletek.co',
};

